import { render, staticRenderFns } from "./SchoolAuth.vue?vue&type=template&id=f14f8390&scoped=true&"
import script from "./SchoolAuth.vue?vue&type=script&lang=js&"
export * from "./SchoolAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14f8390",
  null
  
)

export default component.exports